import { render, staticRenderFns } from "./Ticketviewer_Car.vue?vue&type=template&id=70571f6b&"
import script from "./Ticketviewer_Car.vue?vue&type=script&lang=js&"
export * from "./Ticketviewer_Car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports